
    <div class="deck-container" [ngClass]="{'desktop': device.isDesktop || device.isTablet, 'mobile': device.isMobile }">
        <div class="deck-header" *ngIf="device.isMobile">
            <!-- Logo -->
            <div *ngIf="!isMainDomain &&  preview?.transfer?.customization?.logo?.sourceUrl" class="domain-logo-container">
                <div class="domain-logo" [appBackgroundImage]="preview?.transfer?.customization?.logo?.sourceUrl" ></div>
            </div>
        
            <div *ngIf="isMainDomain || !preview?.transfer?.customization?.logo?.sourceUrl" class="smash-logo">
                <i class="icon-smash_icologo_chip"></i>
            </div>
            
            <!-- Freemium Text -->
            <div *ngIf="!isMainDomain && preview" class="freemium-description" translate [translateParams]="{ count: preview?.transfer.filesNumber }">VIEWER_MOBILE_HEADER</div>
            <!-- Transfer-metas -->
            <div *ngIf="preview" class="transfer-metas">
                <div *ngIf="preview?.transfer.title" class="transfer-title">{{preview.transfer.title}}</div>
                <div class="transfer-infos">
                    <div class="files-count" translate [translateParams]="{ count: preview.transfer.filesNumber }">VIEWER_FILES</div>
                    <div>•</div>
                    <div class="transfer-size">{{preview?.transfer.size | bytes:2}}</div>
                    <div>•</div>
                    <app-smash-countdown [endDate]="preview.transfer.availabilityEndDate"></app-smash-countdown>
                </div>
            </div>
        </div>
        <app-file-card 
            [id]="file.id"
            [ngClass]="{'card-mobile': device.isMobile}" 
            *ngFor="let file of files; trackBy:identify" 
            [file]="file"
            [files]="files"
            (videoPlaying)="onVideoPlaying($event)"
            [selectedFiles]="selectedFiles" 
            [device]="device">
        </app-file-card>
    </div>
    
    <div class="loading-container" *ngIf="(filesLoading$ | async) && preview">
        <div class="loading-spinner-grey"></div>
    </div>
    <div class="deck-button-showmore-container" *ngIf="!(filesLoading$ | async) && preview?.transfer.filesNumber > files?.length">
        <button class="deck-button-showmore" (click)="getItems()">{{ 'VIEWER_DISPLAY_MORE' | translate }}</button>
    </div>
